/** Reachable because `/api/auth/me` is exempt from that gate. */
import { useTranslation } from 'react-i18next'

import ImpersonationBanner from './ImpersonationBanner'
import { accountHandle } from '../lib/password'
import type { User } from '../lib/types'

export default function NoAccessLevel({ user }: { user: User }) {
  const { t } = useTranslation()

  return (
    <div className="flex min-h-screen flex-col bg-slate-50 dark:bg-slate-900">
      <ImpersonationBanner user={user} />
      <div className="flex flex-1 items-center justify-center p-6">
        <div className="max-w-md space-y-3 rounded-xl border border-slate-200 bg-white p-6 dark:border-slate-700 dark:bg-slate-800">
          <h1 className="font-semibold text-slate-800 dark:text-slate-100">
            {t('admin.noAccessTitle')}
          </h1>
          <p className="text-sm text-slate-600 dark:text-slate-300">{t('admin.noAccessBody')}</p>
          {/* Shown so they can tell an administrator which account to look for
              -- a guest often holds more than one Microsoft identity, and "it
              says I'm signed in" is not enough to find the right row. */}
          <p className="text-sm text-slate-500 dark:text-slate-400">
            {t('admin.noAccessSignedInAs', { email: accountHandle(user) })}
          </p>
        </div>
      </div>
    </div>
  )
}
